// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rm2F","left":"styles_left__6--vf","desktopActions":"styles_desktopActions__1lEw9","title":"styles_title__3AceF"};